import React, { ReactElement } from 'react';
import type { Route } from 'next';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import Breadcrumbs from 'components/Breadcrumbs';
import 'swiper/css';
import styles from 'pages/resources/freight-templates/FreightTemplates.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/FreightTemplates/components/SectionHeader/'));
const SectionBenefits = dynamic(() => import('sections/Resources/FreightTemplates/components/SectionBenefits/'));
const SectionTemplates = dynamic(() => import('sections/Resources/FreightTemplates/components/SectionTemplates/'));
const SectionFaq = dynamic(() => import('sections/Resources/FreightTemplates/components/SectionFaq/'));
const SectionCallToAction = dynamic(() => import('sections/Resources/FreightTemplates/components/SectionCallToAction'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Resources/FreightTemplates/components/SectionForm/'));
const SectionRelatedPosts = dynamic(() => import('sections/Resources/FreightTemplates/BillOfLading/components/SectionRelatedPosts/'));

interface BillOfLadingProps {
  articles: TopArticlesCardType[];
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
}

export default function FreightTemplates({ articles, pageTitle, formUrl, leadSubtype }: BillOfLadingProps) {
  return (
    <div className={cn('freight-templates')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            // { title: 'Resources', href: '/resources' },
            { title: 'Freight Templates' , href: '' as Route },
          ]}
        />
      </div>
      <SectionHeader />
      <SectionBenefits />
      <SectionTemplates />
      <SectionCallToAction />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
      <SectionFaq />
      <SectionRelatedPosts articles={articles} />
    </div>
  );
}

export const getStaticProps = async () => {
  const meta = {
    title: 'Freight Templates Free Download | DF Alliance',
    description: 'Download free freight document templates from DF Alliance to streamline your logistics process.',
    path: '/resources/freight-templates',
  };

  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component in 'SectionForm' on all Benefits pages as additional data for CRM: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.FreightTemplates.pageTitle,
  //   formUrl: LeadFormParameters.FreightTemplates.formUrl,
  //   leadSubtype: LeadFormParameters.FreightTemplates.leadSubtype,
  // };

  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return { props: { 
      articles, 
      ...meta, 
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters 
    } };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return {
    props: {
      articles: [],
      ...meta,
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

FreightTemplates.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
